// extracted by mini-css-extract-plugin
export default {"threadsContainer":"ThreadsView_threadsContainer__hoVhE","header":"ThreadsView_header__b5Yns","content":"ThreadsView_content__bW8YT"};